import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrGN: CultureInfo = {
  name: 'fr-GN',
  displayName: 'français (Guinée)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-GN',
  parent: CultureInfoFr
};
